module.exports = __webpack_public_path__ + "static/media/bg-hero-04-M.9830bafa.png";